import { render, staticRenderFns } from "./TalkAskExperience.vue?vue&type=template&id=68c01a2e&scoped=true&"
import script from "./TalkAskExperience.vue?vue&type=script&lang=ts&"
export * from "./TalkAskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./TalkAskExperience.vue?vue&type=style&index=0&id=68c01a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c01a2e",
  null
  
)

export default component.exports